import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Box,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  CheckCircleOutline,
  DoDisturbAlt,
  MoreVert,
  AddCircle,
  RemoveCircle,
  Edit,
  ArrowCircleDown,
  ArrowCircleUp,
  SubdirectoryArrowRight,
  Delete,
  KeyboardReturn,
  Close,
} from "@mui/icons-material";
import {
  get_orders_detail,
  get_report_reason,
  get_sales_order_report_detail,
  manual_customer_return_order,
  reject_report,
  submit_return_report,
  upload_item_images,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";

export default function Return() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [page, setPage] = React.useState(params.return_type);

  const [loading, setLoading] = React.useState(false);
  const [orderData, setOrderData] = React.useState(null);
  const [reasonData, setReasonData] = React.useState(null);
  const [salesOrderReportID, setSalesOrderReportID] = React.useState(null);
  const [selectedReason, setSelectedReason] = React.useState("");
  const [reportData, setReportData] = React.useState({
    invoiceid: "",
    returnreason: "",
    otherreason: "",
    // fullreturn: "",
    item: "",
  });
  const [selectedItem, setSelectedItem] = React.useState([]);
  const [stockReturn, setStockReturn] = React.useState(false);

  const [fullReturn, setFullReturn] = React.useState(false);

  const [retunDetailData, setRetunDetailData] = React.useState([]);

  const [memo, setMemo] = React.useState({
    description: "",
  });

  const [checked, setChecked] = React.useState(false);
  const [defaultChecked, setDefaultChecked] = React.useState("");
  const [imageList, setImageList] = React.useState([]);

  const [prodList, setProdList] = React.useState([]);
  const [currentQty, setCurrentQty] = React.useState({});
  const [chooseReturn, setChooseReturn] = React.useState(3);
  // const [choosedReturn, setChoosedReturn] = React.useState("");

  const [qty, setQty] = React.useState([]);

  const handleChooseReason = (e) => {
    setSelectedReason(e.target.value);
  };

  const handleChooseReturn = (e) => {
    setChooseReturn(e.target.value);
    // setChoosedReturn(e.target.value);
  };

  const getData = () => {
    setLoading(true);
    var temp_data = [];
    get_orders_detail({
      sales_order_id: params.sales_order_id,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setOrderData(json.data);
      // setSalesOrderReportID(json.data.report[0].sales_order_report_id)

      // if (json.data.item.length != 0) {
      //   for (var i = 0; i < json.data.item.length; i++) {
      //     temp_data.push({
      //       ...json.data.item[i],
      //       check: false,
      //     });
      //   }
      //   setSelectedItem(temp_data);
      // }
    });
    get_report_reason({}).then((json) => {
      setLoading(false);
      setReasonData(json.data);
      // setSelectedReason(json.data[0].name)
    });

    get_sales_order_report_detail({
      sales_order_report_id: params.sales_order_report_id,
      sales_order_id: params.sales_order_id,
    }).then((json) => {
      setLoading(false);
      // setReasonData(json.data);
      // setReturnMemo(json.data);

      setRetunDetailData(json.data);
      setMemo(json.data.description);
      // console.log(json.data.description);
      setSelectedReason(json.data.reason);
      setChooseReturn(json.data.stockreturn);
      setImageList(json.images);
      console.log(imageList);
      setProdList(json.item);
      // if (json.data.item.length != 0) {
      //   for (var j = 0; j < json.data.item.length; j++) {
      //     if (json.data.item[j].is_report == 1) {
      //       temp_data.push({
      //         ...json.data.item[j],
      //         check: true,
      //       });
      //     } else {
      //       temp_data.push({
      //         ...json.data.item[j],
      //         check: false,
      //       });
      //     }
      //   }
      //   setSelectedItem(temp_data);
      // }

      for (var i = 0; i < json.item.length; i++) {
        var a = json.item[i].quantity;
        setCurrentQty(a);
        // console.log(JSON.stringify(a));
      }

      if (json.item.length != 0) {
        for (var j = 0; j < json.item.length; j++) {
          if (json.item[j].is_report == 1) {
            temp_data.push({
              ...json.item[j],
              check: true,
            });
          } else {
            temp_data.push({
              ...json.item[j],
              check: false,
            });
          }
        }
        setSelectedItem(temp_data);
      }
    });
  };
  React.useEffect(() => {
    getData();
  }, [salesOrderReportID]);

  // React.useEffect(() => {
  // }, [selectedReason]);

  const handleChangeMemo = (e) => {
    // setMemo({
    //   ...memo,
    //   [e.target.name]: e.target.value,
    // });
    setMemo(e.target.value);
    // setRetunDetailData(e.target.value)
  };

  const [uploadReturn, setUploadReturn] = React.useState("");

  const [disabled, setDisabled] = React.useState(false);

  const handleChangeUploadReturn = async (e) => {
    var formData = new FormData();
    const files = e.target.files;
    formData.append("image_length", files.length);
    for (let i = 0; i < files.length; i++) {
      formData.append("images_" + i, files[i]);
    }
    setDisabled(true);
    upload_item_images(formData).then((res) => {
      if (res.status) {
        setDisabled(false);
        setUploadReturn({
          image: JSON.stringify(res.data.data),
        });
      }
    });
  };

  const handleSubmitReport = () => {
    var temp_itemDataAll = orderData.item;
    var temp_itemDataSelected = [];

    var itemCheck = false;

    for (var i = 0; i < selectedItem.length; i++) {
      if (selectedItem[i]["check"] == true) {
        temp_itemDataSelected.push(selectedItem[i]);
        itemCheck = true;
      }
    }
    if (itemCheck == false) {
      toast("Please Select Item");
      setLoading(false);
      return;
    }
    if (selectedReason == "" || selectedReason == undefined) {
      toast("Please Select a Reason");
      setLoading(false);
      return;
    }

    if (chooseReturn == "" || chooseReturn == undefined) {
      toast("Please Select a Return Type");
      setLoading(false);
      return;
    }

    // console.log(uploadReturn);

    

    
    if(retunDetailData.syn_status != "Success"){
      if (imageList == []) {
        toast("Please Upload an Image");
        setLoading(false);
        return;
      }
    }

    // if (selectedReason == "Others" && reasonData.otherreason == "") {
    //   toast("Please tell a reason");
    //   setLoading(false);
    //   return;
    // }
    // console.log(temp_itemDataSelected);
    setLoading(true);

    let postparam = {
      ...reportData,
      // ...retunDetailData,
      ...uploadReturn,
      memo: memo,
      sales_order_id: params.sales_order_id,
      sales_order_report_id: params.sales_order_report_id,
      // stockreturn: stockReturn ? 1 : 0,
      stockReturn: chooseReturn,
      fullReturn: fullReturn ? 1 : 0,
      invoiceid: orderData.invoiceid,
      returnreason: selectedReason,

      // otherreason: selectedReason == "Others" ? reportData.otherreason : "",
      // fullreturn: params.return_type == 0 ? 1 : 0,
      // item:
      //   params.return_type == 0
      //     ? JSON.stringify(temp_itemDataAll)
      //     : JSON.stringify(temp_itemDataSelected),
      item: JSON.stringify(temp_itemDataSelected),
    };

    // console.log(JSON.stringify(temp_itemDataSelected));
    // console.log(JSON.stringify(postparam));

    submit_return_report(postparam).then((json) => {
      if (typeof json.status !== "undefined") {
        alert(json.message);
        setLoading(false);
        return;
      } else {
        toast("Return Report Submitted");
        navigate("/salereturnlist/" + params.sales_order_id);
      }
    });
  };

  const handleChangeReport = (e) => {
    setReportData({
      ...reportData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSelectItem = (index) => {
    var temp_data = [...selectedItem];
    temp_data[index]["check"] = !temp_data[index]["check"];
    // setSelectedItem(temp_data);

    if (temp_data[index]["check"] && !temp_data[index]["return_quantity"]) {
      // if item is checked and return_quantity is empty, alert the user
      alert("Please enter a value for return_quantity");
    } else {
      setSelectedItem(temp_data);
    }

    // console.log(temp_data);
  };

  const [allSelected, setAllSelected] = React.useState(false);

  const handleSelectAll = () => {
    var temp_data = [...selectedItem];
    const allSelected = temp_data.every((item) => item.check);

    if (!allSelected) {
      temp_data = temp_data.map((item) => ({ ...item, check: true }));
      setFullReturn(true);
    } else {
      temp_data = temp_data.map((item) => ({ ...item, check: false }));
      setFullReturn(false);
    }

    setSelectedItem(temp_data);
    setAllSelected(!allSelected);
  };

  // const handleChangeQuantityItem = (e, index) => {
  //   var temp_data = [...selectedItem];
  //   var newQty = parseInt(e.target.value);
  //   if (newQty > temp_data[index].quantity) {
  //     toast("Your quantity cannot be more than sales quantity");
  //     e.target.value = "";
  //     return;
  //   }
  //   temp_data[index].return_quantity = newQty;
  //   setSelectedItem(temp_data);
  // };

  // const handleChangeQuantityItem = (e, index) => {
  //   var temp_data = [...selectedItem];
  //   var newQty = parseInt(e.target.value);
  //   if (isNaN(newQty)) {
  //     temp_data[index].return_quantity = "";
  //   } else if (newQty > temp_data[index].quantity) {
  //     toast("Your quantity cannot be more than sales quantity");
  //     e.target.value = "";
  //     return;
  //   } else {
  //     temp_data[index].return_quantity = newQty;
  //   }
  //   setSelectedItem(temp_data);
  // };

  const handleChangeQuantityItem = (e, index) => {
    var temp_data = [...selectedItem];
    var newQty = parseInt(e.target.value);
    if (isNaN(newQty)) {
      temp_data[index].return_quantity = "";
    } else {
      temp_data[index].return_quantity = newQty;
    }

    setSelectedItem(temp_data);
  };

  const [token, setToken] = React.useState([]);

  React.useEffect(() => {
    let token = window.localStorage.getItem("token");
    setToken(token || "");
  }, []);

  const [loadingAdd, setLoadingAdd] = React.useState(false);

  const handleRejectReturn = () => {
    setLoadingAdd(true);
    reject_report({
      sales_order_id: params.sales_order_id,
      sales_order_report_id: params.sales_order_report_id,
      token: token,
    }).then((json) => {
      if (json.status) {
        alert("Reject Successfully");
        window.location.reload();
      }
    });
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {page == 0 ? (
            <Navbar2
              children={
                <Section pd="2rem">
                  {orderData != null && (
                    <React.Fragment>
                      <div>
                        <div
                          onClick={() => navigate(-1)}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <Paragraph
                            color="#000"
                            bold="400"
                            size="12px"
                            margin="0 0 1rem"
                          >
                            &lt; Back
                          </Paragraph>
                        </div>
                        <div className={classes.theFlexHeader}>
                          <Paragraph color="#1A5386" bold="600" size="24px">
                            Return Order Number:{" "}
                            {retunDetailData.sales_order_id != "" &&
                            retunDetailData.sales_order_id != null
                              ? retunDetailData.sales_order_id
                              : "-"}
                          </Paragraph>
                          <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            {retunDetailData.rmalink != "" && (
                              <a
                                href={retunDetailData.rmalink}
                                style={{
                                  backgroundColor: "#1A5386",
                                  borderRadius: "4px",
                                  textDecoration: "none",
                                }}
                                className={classes.theCustomActionBtnFill}
                                target="_blank"
                              >
                                <Paragraph margin="0 0 0 .4rem">
                                  RMA PRINT
                                </Paragraph>
                              </a>
                            )}

                            {retunDetailData.cnlink != "" && (
                              <a
                                href={retunDetailData.cnlink}
                                style={{
                                  backgroundColor: "#1A5386",
                                  borderRadius: "4px",
                                  textDecoration: "none",
                                }}
                                className={classes.theCustomActionBtnFill}
                                target="_blank"
                              >
                                <Paragraph margin="0 0 0 .4rem">
                                  CN PRINT
                                </Paragraph>
                              </a>
                            )}
                          </div>
                        </div>
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">SO Number:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  <a
                                    href={`../saledetail/${retunDetailData.sales_order_id}`}
                                  >
                                    {retunDetailData.sales_order_id != "" &&
                                    retunDetailData.sales_order_id != null
                                      ? retunDetailData.sales_order_id
                                      : "-"}
                                  </a>
                                </Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Created Date:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.created_date != "" &&
                                  retunDetailData.created_date != null
                                    ? retunDetailData.created_date
                                    : "-"}
                                </Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Customer Name:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.entityid != "" &&
                                  retunDetailData.entityid != null
                                    ? retunDetailData.entityid
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Contact Number:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.phone != "" &&
                                  retunDetailData.phone != null
                                    ? retunDetailData.phone
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Email:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.email != "" &&
                                  retunDetailData.email != null
                                    ? retunDetailData.email
                                    : "-"}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Payment Type:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.paymenttype}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Currency:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.currency}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Syn Status:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.syn_status}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Status Control:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.status}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <br />
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Shipping Address:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.addr1},
                                </Paragraph>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.addr2},
                                </Paragraph>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.city} {retunDetailData.zip}{" "}
                                  {retunDetailData.state}{" "}
                                  {retunDetailData.country}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <br />
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3}
                                style={{ margin: "auto" }}
                              >
                                <Paragraph size="14px">
                                  Return Reason:{" "}
                                  <span
                                    style={{
                                      color: "#F92000",
                                      marginLeft: "4px",
                                    }}
                                  >
                                    *
                                  </span>
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <FormInputSelect>
                                  <Select
                                    displayEmpty
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                    name="name"
                                    value={selectedReason}
                                    // onChange={handleChooseCountry}
                                    onChange={handleChooseReason}
                                    style={{ marginBottom: "1rem" }}
                                  >
                                    <MenuItem
                                      value=""
                                      style={{ fontWeight: "400" }}
                                    >
                                      <em style={{ color: "#878787" }}>
                                        Please Choose a Reasons
                                      </em>
                                    </MenuItem>
                                    {reasonData != null &&
                                      reasonData.map((res) => (
                                        <MenuItem value={res.name}>
                                          {res.name}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormInputSelect>
                                {/* <FormInput
                                  value={selectedReason}
                                  textLabelColor="#000"
                                  name="quantity"
                                  border="1px solid #c5c5c5"
                                  mb="0"
                                  onChange={(e) =>
                                    setSelectedReason(e.target.value)
                                  }
                                  select
                                >
                                  {reasonData != null &&
                                    reasonData.map((res) => (
                                      <MenuItem value={res.name}>
                                        {res.name}
                                      </MenuItem>
                                    ))}
                                </FormInput> */}
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3}
                                style={{ margin: "auto" }}
                              >
                                <Paragraph size="14px">Stock Return:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                {/* <Checkbox
                                  onChange={() => setStockReturn(!stockReturn)}
                                  checked={stockReturn}
                                  sx={{
                                    padding: "0 .4rem 0 0",
                                    color: "#1A5386 ",
                                    "&.Mui-checked": {
                                      color: "#1A5386 ",
                                    },
                                  }}
                                />
                                {stockReturn ? "Yes" : "No"} */}
                                <FormInputNoLabel
                                  // name="color"
                                  // placeholder="Search"
                                  disabled
                                  border="1px solid #d7d7d7"
                                  br="6px"
                                  onChange={handleChooseReturn}
                                  value={chooseReturn}
                                  select
                                >
                                  <MenuItem value="3">
                                    <em style={{ color: "#878787" }}>
                                      Please Select Return Type
                                    </em>
                                  </MenuItem>
                                  <MenuItem value="1" style={{ color: "#000" }}>
                                    Stock Return
                                  </MenuItem>
                                  <MenuItem value="0" style={{ color: "#000" }}>
                                    No Stock Return
                                  </MenuItem>
                                </FormInputNoLabel>
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3}
                                style={{ margin: "auto" }}
                              >
                                <Paragraph size="14px">Full Return:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Checkbox
                                  // onChange={() => setFullReturn(!fullReturn)}
                                  onChange={handleSelectAll}
                                  checked={fullReturn}
                                  sx={{
                                    padding: "0 .4rem 0 0",
                                    color: "#1A5386 ",
                                    "&.Mui-checked": {
                                      color: "#1A5386 ",
                                    },
                                  }}
                                />
                                {fullReturn ? "Yes" : "No"}
                              </Grid>

                              <Grid
                                item
                                xs={12}
                                sm={4}
                                md={3}
                                style={{ margin: "auto" }}
                              >
                                <Paragraph size="14px">Memo:</Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={8} md={9}>
                                <FormInput
                                  // value={retunDetailData.description}
                                  textLabelColor="#000"
                                  name="memo"
                                  border="1px solid #c5c5c5"
                                  mb="0"
                                  onChange={handleChangeMemo}
                                  // onChange={(e) => setMemo(e.target.value)}
                                  multiline
                                  minRows={4}
                                ></FormInput>
                              </Grid>
                            </Grid>
                          </Grid>
                          {selectedReason == "Others" && (
                            <Grid item xs={12} sm={12} md={6}>
                              <Grid container spacing={3}>
                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Others Reason:
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  <FormInput
                                    value={reportData.otherreason}
                                    textLabelColor="#000"
                                    name="otherreason"
                                    border="1px solid #c5c5c5"
                                    mb="0"
                                    onChange={handleChangeReport}
                                  />
                                </Grid>
                              </Grid>
                            </Grid>
                          )}
                        </Grid>
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <Card className={classes.theCard}>
                              <div className={classes.theFlexHeader2}>
                                <Paragraph size="22px" bold="600">
                                  Product List
                                </Paragraph>
                                <div
                                  className={classes.theFlexBtn}
                                  style={{ marginBottom: "0" }}
                                >
                                  {orderData.status_id == 1 && (
                                    <a
                                      style={{ border: 0 }}
                                      className={classes.theCustomActionBtn}
                                      onClick={() => setPage("product")}
                                    >
                                      <AddCircle sx={{ color: "#1A5386" }} />
                                      <Paragraph margin="0 0 0 .4rem">
                                        Add Item
                                      </Paragraph>
                                    </a>
                                  )}
                                </div>
                              </div>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #707070",
                                }}
                              ></div>
                              <br />
                              <TableContainer>
                                <Table>
                                  <TableHead
                                    style={{ backgroundColor: "#fff" }}
                                  >
                                    <TableRow>
                                      {retunDetailData.status == "Open" ||
                                      retunDetailData.status == "Error" ? (
                                        <TableCell
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                          <Checkbox
                                            sx={{
                                              visibility: "hidden",
                                              color: "#fff",
                                              "&.Mui-checked": {
                                                color: "#fff",
                                              },
                                            }}
                                          />
                                        </TableCell>
                                      ) : (
                                        <></>
                                      )}

                                      <TableCell
                                        className={classes.theHeadTitle_}
                                      >
                                        Item Name
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle_}
                                      >
                                        Description
                                      </TableCell>

                                      <TableCell
                                        className={classes.theHeadTitle_}
                                      >
                                        Price
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Discount Amount
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Sales Quantity
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Return Quantity
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Returned Quantity
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle_}
                                      >
                                        Total Price
                                      </TableCell>
                                      {orderData.status_id == 1 && (
                                        <TableCell
                                          align="center"
                                          style={{
                                            borderRadius: "0 10px 10px 0",
                                          }}
                                          className={classes.theHeadTitle_}
                                        >
                                          <MoreVert sx={{ color: "#000" }} />
                                        </TableCell>
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {orderData.item.map((item, index) => {
                                      return (
                                        <TableRow>
                                          {retunDetailData.status == "Open" ||
                                          retunDetailData.status == "Error" ? (
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "5%",
                                              }}
                                            >
                                              <>
                                                {item.remainingamt != 0 && (
                                                  <Checkbox
                                                    onChange={() =>
                                                      handleSelectItem(index)
                                                    }
                                                    value={defaultChecked}
                                                    disabled={allSelected}
                                                    checked={item.check}
                                                    sx={{
                                                      color: "#1A5386 ",
                                                      "&.Mui-checked": {
                                                        color: "#1A5386 ",
                                                      },
                                                    }}
                                                  />
                                                )}
                                              </>
                                            </TableCell>
                                          ) : (
                                            <></>
                                          )}

                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "15%",
                                            }}
                                          >
                                            {item.itemname != "" &&
                                            item.itemname != null
                                              ? item.itemname
                                              : "-"}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "15%",
                                            }}
                                          >
                                            {item.description != "" &&
                                            item.description != null
                                              ? item.description
                                              : "-"}
                                          </TableCell>

                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                            }}
                                          >
                                            {item.price}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                            }}
                                          >
                                            {item.discountamount}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                            }}
                                          >
                                            {item.quantity}
                                          </TableCell>
                                          {retunDetailData.status == "Open" ||
                                          retunDetailData.status == "Error" ? (
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                              }}
                                            >
                                              <FormInput
                                                value={item.return_quantity}
                                                textLabelColor="#000"
                                                bold="600"
                                                mb="0"
                                                border={
                                                  item.return_quantity >
                                                  item.remain_quantity
                                                    ? "1px solid #F90000"
                                                    : "1px solid #707070"
                                                }
                                                size="12px"
                                                disabled={allSelected}
                                                onKeyPress={(event) => {
                                                  if (
                                                    event.target.value == "" &&
                                                    !/[1-9]/.test(event.key)
                                                  ) {
                                                    event.preventDefault();
                                                  }
                                                }}
                                                onChange={(e) =>
                                                  handleChangeQuantityItem(
                                                    e,
                                                    index
                                                  )
                                                }
                                              />
                                            </TableCell>
                                          ) : (
                                            <TableCell
                                              style={{
                                                background:
                                                  index % 2 == 0
                                                    ? "#E0F0F7"
                                                    : "#fff",
                                                width: "10%",
                                                textAlign: "center",
                                              }}
                                            >
                                              {item.return_quantity}
                                            </TableCell>
                                          )}
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                              textAlign: "center",
                                            }}
                                          >
                                            {item.returned_quantity}
                                          </TableCell>
                                          <TableCell
                                            style={{
                                              background:
                                                index % 2 == 0
                                                  ? "#E0F0F7"
                                                  : "#fff",
                                              width: "10%",
                                            }}
                                          >
                                            {item.subtotal}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #f2f2f2",
                                }}
                              ></div>
                              <br />
                              <div className={classes.theTotal}>
                                <Grid container spacing={3}>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph size="14px">Amount:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {retunDetailData.currency} {orderData.total_amount}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph size="14px">
                                      Shipping Fee:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {retunDetailData.currency} {orderData.shipping_fee}
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph size="14px">
                                      Handling Fee:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {retunDetailData.currency} {orderData.handling_fee}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </div>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #f2f2f2",
                                }}
                              ></div>
                              <br />
                              <div className={classes.theTotal}>
                                <Grid container spacing={3}>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph size="14px">Total:</Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={4} md={6}>
                                    <Paragraph
                                      size="14px"
                                      bold="600"
                                      style={{ textAlign: "right" }}
                                    >
                                      {retunDetailData.currency} {orderData.final_amount}
                                    </Paragraph>
                                  </Grid>
                                </Grid>
                              </div>
                            </Card>
                            <br />
                            <br />
                          </Grid>
                        </Grid>
                        <div
                          className={classes.theFlexBtn}
                          style={{ marginBottom: "0" }}
                        >
                          <a
                            className={classes.theAddCustomActionBtnFill}
                            onClick={() => handleSubmitReport()}
                          >
                            {/* <CheckCircleOutline sx={{ color: "#fff" }} /> */}
                            <Paragraph margin="0 0 0 .4rem">
                              Submit Report
                            </Paragraph>
                          </a>
                        </div>
                        <br />
                        <br />
                      </div>
                    </React.Fragment>
                  )}
                </Section>
              }
            />
          ) : (
            <Navbar2
              children={
                <Section pd="2rem">
                  {orderData != null && (
                    <React.Fragment>
                      <div>
                        <div
                          onClick={() => navigate(-1)}
                          style={{
                            cursor: "pointer",
                          }}
                        >
                          <Paragraph
                            color="#000"
                            bold="400"
                            size="12px"
                            margin="0 0 1rem"
                          >
                            &lt; Back
                          </Paragraph>
                        </div>
                        <div className={classes.theFlexHeader}>
                          <Paragraph color="#1A5386" bold="600" size="24px">
                            Return Order Number:{" "}
                            {retunDetailData.sales_order_report_id != "" &&
                            retunDetailData.sales_order_report_id != null
                              ? retunDetailData.sales_order_report_id
                              : "-"}
                          </Paragraph>
                        <Box sx={{display: "flex"}}>
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            {retunDetailData.rmalink != "" && (
                              <a
                                href={retunDetailData.rmalink}
                                style={{
                                  backgroundColor: "#1A5386",
                                  borderRadius: "4px",
                                  textDecoration: "none",
                                }}
                                className={classes.theCustomActionBtnFill}
                                target="_blank"
                              >
                                <Paragraph margin="0 0 0 .4rem">
                                  RMA PRINT
                                </Paragraph>
                              </a>
                            )}

                            {retunDetailData.cnlink != "" && (
                              <a
                                href={retunDetailData.cnlink}
                                style={{
                                  backgroundColor: "#1A5386",
                                  borderRadius: "4px",
                                  textDecoration: "none",
                                }}
                                className={classes.theCustomActionBtnFill}
                                target="_blank"
                              >
                                <Paragraph margin="0 0 0 .4rem">
                                  CN PRINT
                                </Paragraph>
                              </a>
                            )}
                          </div>
                          {loadingAdd ? (
                            <div style={{}}>
                              <Loader
                                type="bubble-loop"
                                bgColor="#1A5386"
                                size={50}
                              />
                            </div>
                          ) : (
                            <>
                              {retunDetailData.status == "Open" && (
                                <a
                                  style={{ backgroundColor: "#F90000" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleRejectReturn()}
                                >
                                  <Close sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Reject Return
                                  </Paragraph>
                                </a>
                              )}
                               {retunDetailData.status == "Pending Return" && (
                                <a
                                  style={{ backgroundColor: "#F90000" }}
                                  className={classes.theCustomActionBtnFill}
                                  onClick={() => handleRejectReturn()}
                                >
                                  <Close sx={{ color: "#fff" }} />
                                  <Paragraph margin="0 0 0 .4rem">
                                    Reject Return
                                  </Paragraph>
                                </a>
                              )}
                            </>
                          )}
                        </Box>
                        </div>
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">SO Number:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  <a
                                    href={`/saledetail/${retunDetailData.sales_order_id}`}
                                  >
                                    {retunDetailData.sales_order_id != "" &&
                                    retunDetailData.sales_order_id != null
                                      ? retunDetailData.sales_order_id
                                      : "-"}
                                  </a>
                                </Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Created Date:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.created_date != "" &&
                                  retunDetailData.created_date != null
                                    ? retunDetailData.created_date
                                    : "-"}
                                </Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Customer Name:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.entityid != "" &&
                                  retunDetailData.entityid != null
                                    ? retunDetailData.entityid
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Contact Number:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.phone != "" &&
                                  retunDetailData.phone != null
                                    ? retunDetailData.phone
                                    : "-"}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Email:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.email != "" &&
                                  retunDetailData.email != null
                                    ? retunDetailData.email
                                    : "-"}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Payment Type:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.paymenttype}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Currency:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.currency}
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">Syn Status:</Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.syn_status}
                                </Paragraph>
                              </Grid>

                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Status Control:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.status}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <br />
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={6}>
                            <Grid container spacing={3}>
                              <Grid item xs={12} sm={4} md={3}>
                                <Paragraph size="14px">
                                  Shipping Address:
                                </Paragraph>
                              </Grid>
                              <Grid item xs={12} sm={8} md={9}>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.addr1},
                                </Paragraph>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.addr2},
                                </Paragraph>
                                <Paragraph size="14px" bold="600">
                                  {retunDetailData.city} {retunDetailData.zip}{" "}
                                  {retunDetailData.state}{" "}
                                  {retunDetailData.country}
                                </Paragraph>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                        <br />
                        <div
                          style={{
                            borderBottom: "2px solid #707070",
                            padding: ".2rem 0",
                          }}
                        />
                        <br />

                        {retunDetailData.syn_status == "Success" ? (
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={6}>
                              <Grid container spacing={3}>
                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Return Reason:{" "}
                                    <span
                                      style={{
                                        color: "#F92000",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      *
                                    </span>
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  <FormInput
                                    disabled
                                    value={selectedReason}
                                    textLabelColor="#000"
                                    name="quantity"
                                    border="1px solid #c5c5c5"
                                    mb="0"
                                    onChange={(e) =>
                                      setSelectedReason(e.target.value)
                                    }
                                    select
                                  >
                                    {reasonData != null &&
                                      reasonData.map((res) => (
                                        <MenuItem value={res.name}>
                                          {res.name}
                                        </MenuItem>
                                      ))}
                                  </FormInput>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Stock Return:
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  {/* <Checkbox
                                    disabled
                                    onChange={() =>
                                      setStockReturn(!stockReturn)
                                    }
                                    checked={stockReturn}
                                    sx={{
                                      padding: "0 .4rem 0 0",
                                      color: "#1A5386 ",
                                      "&.Mui-checked": {
                                        color: "#1A5386 ",
                                      },
                                    }}
                                  />
                                  {stockReturn ? "Yes" : "No"} */}

                                  <FormInputNoLabel
                                    // name="color"
                                    // placeholder="Search"
                                    disabled
                                    border="1px solid #d7d7d7"
                                    br="6px"
                                    onChange={handleChooseReturn}
                                    value={chooseReturn}
                                    select
                                  >
                                    <MenuItem value="3">
                                      <em style={{ color: "#878787" }}>
                                        Please Select Return Type
                                      </em>
                                    </MenuItem>
                                    <MenuItem
                                      value="1"
                                      style={{ color: "#000" }}
                                    >
                                      Stock Return
                                    </MenuItem>
                                    <MenuItem
                                      value="0"
                                      style={{ color: "#000" }}
                                    >
                                      No Stock Return
                                    </MenuItem>
                                  </FormInputNoLabel>
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Full Return:
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  <Checkbox
                                    disabled
                                    // onChange={() => setFullReturn(!fullReturn)}
                                    onChange={handleSelectAll}
                                    checked={fullReturn}
                                    sx={{
                                      padding: "0 .4rem 0 0",
                                      color: "#1A5386 ",
                                      "&.Mui-checked": {
                                        color: "#1A5386 ",
                                      },
                                    }}
                                  />
                                  {fullReturn ? "Yes" : "No"}
                                </Grid>

                                <Grid item xs={12} sm={4} md={3}>
                                  <Paragraph size="14px">Memo:</Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  <FormInput
                                    disabled
                                    value={memo}
                                    textLabelColor="#000"
                                    name="memo"
                                    border="1px solid #c5c5c5"
                                    mb="0"
                                    // onChange={(e) => setMemo(e.target.value)}
                                    onChange={handleChangeMemo}
                                    multiline
                                    minRows={4}
                                  ></FormInput>
                                </Grid>
                                <>
                                  {imageList != "" ? (
                                    <>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Paragraph size="14px">
                                          View Image:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={12} sm={8} md={9}>
                                        <div>
                                          {imageList.map((item) => (
                                            <div className={classes.theImgBox}>
                                              <img src={item.image} />
                                            </div>
                                          ))}
                                        </div>
                                      </Grid>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                              {selectedReason == "Others" && (
                                <Grid container spacing={3}>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={3}
                                    style={{ margin: "auto" }}
                                  >
                                    <Paragraph size="14px">
                                      Others Reason:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <FormInput
                                      value={retunDetailData.otherreason}
                                      textLabelColor="#000"
                                      name="otherreason"
                                      border="1px solid #c5c5c5"
                                      mb="0"
                                      onChange={handleChangeReport}
                                      disabled
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        ) : (
                          <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={6}>
                              <Grid container spacing={3}>
                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Return Reason:{" "}
                                    <span
                                      style={{
                                        color: "#F92000",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      *
                                    </span>
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  {/* <FormInput
                                    value={selectedReason}
                                    textLabelColor="#000"
                                    name="quantity"
                                    border="1px solid #c5c5c5"
                                    mb="0"
                                    onChange={(e) =>
                                      setSelectedReason(e.target.value)
                                    }
                                    select
                                  >
                                    {reasonData != null &&
                                      reasonData.map((res) => (
                                        <MenuItem value={res.name}>
                                          {res.name}
                                        </MenuItem>
                                      ))}
                                  </FormInput> */}
                                  <FormInputSelect>
                                    <Select
                                      displayEmpty
                                      inputProps={{
                                        "aria-label": "Without label",
                                      }}
                                      value={selectedReason}
                                      textLabelColor="#000"
                                      // name="quantity"
                                      border="1px solid #c5c5c5"
                                      mb="0"
                                      onChange={handleChooseReason}
                                    >
                                      <MenuItem
                                        value=""
                                        style={{ fontWeight: "400" }}
                                      >
                                        <em style={{ color: "#878787" }}>
                                          Please Choose a Reason
                                        </em>
                                      </MenuItem>
                                      {reasonData != null &&
                                        reasonData.map((res) => (
                                          <MenuItem value={res.name}>
                                            {res.name}
                                          </MenuItem>
                                        ))}
                                    </Select>
                                  </FormInputSelect>
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Stock Return:
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  {/* <Checkbox
                                    onChange={() =>
                                      setStockReturn(!stockReturn)
                                    }
                                    checked={stockReturn}
                                    sx={{
                                      padding: "0 .4rem 0 0",
                                      color: "#1A5386 ",
                                      "&.Mui-checked": {
                                        color: "#1A5386 ",
                                      },
                                    }}
                                  />
                                  {stockReturn ? "Yes" : "No"} */}

                                  <FormInputNoLabel
                                    // name="color"
                                    // placeholder="Search"
                                    border="1px solid #d7d7d7"
                                    br="6px"
                                    onChange={handleChooseReturn}
                                    value={chooseReturn}
                                    select
                                  >
                                    <MenuItem value="3">
                                      {" "}
                                      <em style={{ color: "#878787" }}>
                                        Please Select Return Type
                                      </em>
                                    </MenuItem>
                                    <MenuItem
                                      value="1"
                                      style={{ color: "#000" }}
                                    >
                                      Stock Return
                                    </MenuItem>
                                    <MenuItem
                                      value="0"
                                      style={{ color: "#000" }}
                                    >
                                      No Stock Return
                                    </MenuItem>
                                  </FormInputNoLabel>
                                </Grid>

                                <Grid
                                  item
                                  xs={12}
                                  sm={4}
                                  md={3}
                                  style={{ margin: "auto" }}
                                >
                                  <Paragraph size="14px">
                                    Full Return:
                                  </Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  <Checkbox
                                    // onChange={() => setFullReturn(!fullReturn)}
                                    onChange={handleSelectAll}
                                    checked={fullReturn}
                                    sx={{
                                      padding: "0 .4rem 0 0",
                                      color: "#1A5386 ",
                                      "&.Mui-checked": {
                                        color: "#1A5386 ",
                                      },
                                    }}
                                  />
                                  {fullReturn ? "Yes" : "No"}
                                </Grid>

                                <Grid item xs={12} sm={4} md={3}>
                                  <Paragraph size="14px">Memo:</Paragraph>
                                </Grid>
                                <Grid item xs={12} sm={8} md={9}>
                                  <FormInput
                                    value={memo != "undefined" ? memo : ""}
                                    textLabelColor="#000"
                                    name="memo"
                                    border="1px solid #c5c5c5"
                                    mb="0"
                                    // onChange={(e) => setMemo(e.target.value)}
                                    onChange={handleChangeMemo}
                                    multiline
                                    minRows={4}
                                  ></FormInput>
                                </Grid>
                                <>
                                  <Grid item xs={12} sm={4} md={3}>
                                    <Paragraph size="14px">
                                      Upload Images:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <Box sx={{ display: "flex" }}>
                                      <input
                                        style={{
                                          color: "#000",
                                          border: "1px solid #eaeaea",
                                          borderRadius: 4,
                                          padding: ".4rem 1rem",
                                          width: "-webkit-fill-available",
                                          lineHeight: "1.4375em",
                                          fontSize: "1rem",
                                        }}
                                        type="file"
                                        name="image"
                                        onChange={handleChangeUploadReturn}
                                        multiple
                                      />
                                      {!disabled ? (
                                        <></>
                                      ) : (
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            width: "100px",
                                            height: "35px",
                                          }}
                                        >
                                          <Loader
                                            type="snipper-default"
                                            bgColor={"#878787"}
                                            size={30}
                                          />
                                        </div>
                                      )}
                                    </Box>
                                  </Grid>
                                </>
                                <>
                                  {imageList != "" ? (
                                    <>
                                      <Grid item xs={12} sm={4} md={3}>
                                        <Paragraph size="14px">
                                          View Image:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={12} sm={8} md={9}>
                                        <div>
                                          {imageList.map((item) => (
                                            <div className={classes.theImgBox}>
                                              <img src={item.image} />
                                            </div>
                                          ))}
                                        </div>
                                      </Grid>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={6}>
                              {selectedReason == "Others" && (
                                <Grid container spacing={3}>
                                  <Grid
                                    item
                                    xs={12}
                                    sm={4}
                                    md={3}
                                    style={{ margin: "auto" }}
                                  >
                                    <Paragraph size="14px">
                                      Others Reason:
                                    </Paragraph>
                                  </Grid>
                                  <Grid item xs={12} sm={8} md={9}>
                                    <FormInput
                                      value={reportData.otherreason}
                                      textLabelColor="#000"
                                      name="otherreason"
                                      border="1px solid #c5c5c5"
                                      mb="0"
                                      onChange={handleChangeReport}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                        )}

                        <br />
                        <Grid container spacing={3}>
                          <Grid item xs={12} sm={12} md={12}>
                            <Card className={classes.theCard}>
                              <div className={classes.theFlexHeader2}>
                                <Paragraph size="22px" bold="600">
                                  Product List
                                </Paragraph>
                                <div
                                  className={classes.theFlexBtn}
                                  style={{ marginBottom: "0" }}
                                >
                                  {orderData.status_id == 1 && (
                                    <a
                                      style={{ border: 0 }}
                                      className={classes.theCustomActionBtn}
                                      onClick={() => setPage("product")}
                                    >
                                      <AddCircle sx={{ color: "#1A5386" }} />
                                      <Paragraph margin="0 0 0 .4rem">
                                        Add Item
                                      </Paragraph>
                                    </a>
                                  )}
                                </div>
                              </div>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #707070",
                                }}
                              ></div>
                              <br />
                              <TableContainer>
                                <Table>
                                  <TableHead
                                    style={{ backgroundColor: "#1A5386" }}
                                  >
                                    <TableRow>
                                      {retunDetailData.status == "Open" ||
                                      retunDetailData.status == "Error" ? (
                                        <TableCell
                                          style={{
                                            borderRadius: "10px 0 0 10px",
                                          }}
                                          className={classes.theHeadTitle}
                                        >
                                          <Checkbox
                                            sx={{
                                              visibility: "hidden",
                                              color: "#fff",
                                              "&.Mui-checked": {
                                                color: "#fff",
                                              },
                                            }}
                                          />
                                        </TableCell>
                                      ) : (
                                        <></>
                                      )}

                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Item Name
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Description
                                      </TableCell>

                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Price
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Discount Amount
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Sales Quantity
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Return Quantity
                                      </TableCell>
                                      <TableCell
                                        className={classes.theHeadTitle}
                                      >
                                        Returned Quantity
                                      </TableCell>
                                      <TableCell
                                        style={{
                                          borderRadius: "0 10px 10px 0",
                                        }}
                                        className={classes.theHeadTitle}
                                      >
                                        Total Price
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {selectedItem.length != 0 &&
                                      selectedItem.map((item, index) => {
                                        return (
                                          <>
                                            {item.is_display == 1 && (
                                              <TableRow>
                                                {item.quantity ===
                                                item.returned_quantity ? (
                                                  <>
                                                    {retunDetailData.status ==
                                                      "Open" ||
                                                    retunDetailData.status ==
                                                      "Error" ? (
                                                      <TableCell
                                                        style={{
                                                          background:
                                                            index % 2 == 0
                                                              ? "#E0F0F7"
                                                              : "#fff",
                                                          width: "5%",
                                                        }}
                                                      >
                                                        <>
                                                          {item.remainingamt !=
                                                            0 && (
                                                            <Checkbox
                                                              onChange={() =>
                                                                handleSelectItem(
                                                                  index
                                                                )
                                                              }
                                                              value={
                                                                defaultChecked
                                                              }
                                                              disabled
                                                              checked
                                                              sx={{
                                                                color:
                                                                  "#00000042 ",
                                                                "&.Mui-checked":
                                                                  {
                                                                    color:
                                                                      "#00000042 ",
                                                                  },
                                                              }}
                                                            />
                                                          )}
                                                        </>
                                                      </TableCell>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </>
                                                ) : (
                                                  <>
                                                    {retunDetailData.status ==
                                                      "Open" ||
                                                    retunDetailData.status ==
                                                      "Error" ? (
                                                      <TableCell
                                                        style={{
                                                          background:
                                                            index % 2 == 0
                                                              ? "#E0F0F7"
                                                              : "#fff",
                                                          width: "5%",
                                                        }}
                                                      >
                                                        <>
                                                          {item.remainingamt !=
                                                            0 && (
                                                            <Checkbox
                                                              onChange={() =>
                                                                handleSelectItem(
                                                                  index
                                                                )
                                                              }
                                                              value={
                                                                defaultChecked
                                                              }
                                                              disabled={
                                                                allSelected
                                                              }
                                                              checked={
                                                                item.check
                                                              }
                                                              sx={{
                                                                color:
                                                                  "#1A5386 ",
                                                                "&.Mui-checked":
                                                                  {
                                                                    color:
                                                                      "#1A5386 ",
                                                                  },
                                                              }}
                                                            />
                                                          )}
                                                        </>
                                                      </TableCell>
                                                    ) : (
                                                      <></>
                                                    )}
                                                  </>
                                                )}

                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "15%",
                                                  }}
                                                >
                                                  {item.itemname != "" &&
                                                  item.itemname != null
                                                    ? item.itemname
                                                    : "-"}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "15%",
                                                  }}
                                                >
                                                  {item.description != "" &&
                                                  item.description != null
                                                    ? item.description
                                                    : "-"}
                                                </TableCell>

                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                  }}
                                                >
                                                  {item.price}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                  }}
                                                >
                                                  {item.discountamount}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {item.quantity}
                                                </TableCell>

                                                {retunDetailData.status ==
                                                  "Open" ||
                                                retunDetailData.status ==
                                                  "Error" ? (
                                                  <TableCell
                                                    style={{
                                                      background:
                                                        index % 2 == 0
                                                          ? "#E0F0F7"
                                                          : "#fff",
                                                      width: "10%",
                                                    }}
                                                  >
                                                    <FormInput
                                                      value={
                                                        item.return_quantity
                                                      }
                                                      textLabelColor="#000"
                                                      bold="600"
                                                      mb="0"
                                                      border={
                                                        item.return_quantity >
                                                        item.remain_quantity
                                                          ? "1px solid #F90000"
                                                          : "1px solid #707070"
                                                      }
                                                      size="12px"
                                                      disabled={allSelected}
                                                      onKeyPress={(event) => {
                                                        if (
                                                          event.target.value ==
                                                            "" &&
                                                          !/[1-9]/.test(
                                                            event.key
                                                          )
                                                        ) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                      onChange={(e) =>
                                                        handleChangeQuantityItem(
                                                          e,
                                                          index
                                                        )
                                                      }
                                                    />
                                                  </TableCell>
                                                ) : (
                                                  <TableCell
                                                    style={{
                                                      background:
                                                        index % 2 == 0
                                                          ? "#E0F0F7"
                                                          : "#fff",
                                                      width: "10%",
                                                      textAlign: "center",
                                                    }}
                                                  >
                                                    {item.return_quantity}
                                                  </TableCell>
                                                )}
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  {item.returned_quantity}
                                                </TableCell>
                                                <TableCell
                                                  style={{
                                                    background:
                                                      index % 2 == 0
                                                        ? "#E0F0F7"
                                                        : "#fff",
                                                    width: "10%",
                                                  }}
                                                >
                                                  {item.subtotal}
                                                </TableCell>
                                              </TableRow>
                                            )}
                                          </>
                                        );
                                      })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                              <br />
                              <div
                                style={{
                                  borderBottom: "2px solid #f2f2f2",
                                }}
                              ></div>
                              <br />
                              <Grid container spacing={3}>
                                <Grid item xs={12} sm={6}></Grid>
                                <Grid item xs={12} sm={6}>
                                  <div className={classes.theTotal}>
                                    <Grid container spacing={3}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph size="14px">
                                          Amount:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph
                                          size="14px"
                                          bold="600"
                                          style={{ textAlign: "right" }}
                                        >
                                          {retunDetailData.currency} {orderData.total_amount}
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph size="14px">
                                          Discount Amount:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph
                                          size="14px"
                                          bold="600"
                                          style={{ textAlign: "right" }}
                                        >
                                          {retunDetailData.currency} {orderData.discountamount}
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph size="14px">
                                          Shipping Fee:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph
                                          size="14px"
                                          bold="600"
                                          style={{ textAlign: "right" }}
                                        >
                                          {retunDetailData.currency} {orderData.shipping_fee}
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph size="14px">
                                          Handling Fee:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph
                                          size="14px"
                                          bold="600"
                                          style={{ textAlign: "right" }}
                                        >
                                          {retunDetailData.currency} {orderData.handling_fee}
                                        </Paragraph>
                                      </Grid>
                                    </Grid>
                                  </div>
                                  <br />
                                  <div
                                    style={{
                                      borderBottom: "2px solid #f2f2f2",
                                    }}
                                  ></div>
                                  <br />
                                  <div className={classes.theTotal}>
                                    <Grid container spacing={3}>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph size="14px">
                                          Total:
                                        </Paragraph>
                                      </Grid>
                                      <Grid item xs={6} sm={6} md={6}>
                                        <Paragraph
                                          size="14px"
                                          bold="600"
                                          style={{ textAlign: "right" }}
                                        >
                                          {retunDetailData.currency} {orderData.final_amount}
                                        </Paragraph>
                                      </Grid>
                                    </Grid>
                                  </div>
                                </Grid>
                              </Grid>
                            </Card>
                            <br />
                            <br />
                          </Grid>
                        </Grid>
                        <div
                          className={classes.theFlexBtn}
                          style={{ marginBottom: "0" }}
                        >
                          {retunDetailData.status == "Open" ||
                          retunDetailData.status == "Error" ? (
                            <>
                              {!disabled ? (
                                <a
                                  className={classes.theAddCustomActionBtnFill}
                                  onClick={() => handleSubmitReport()}
                                >
                                  <Paragraph margin="0 0 0 .4rem">
                                    Confirm Issue/Return
                                  </Paragraph>
                                </a>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100px",
                                    height: "35px",
                                  }}
                                >
                                  <Loader
                                    type="snipper-default"
                                    bgColor={"#878787"}
                                    size={30}
                                  />
                                </div>
                              )}
                            </>
                          ) : (
                            <></>
                          )}

                          {retunDetailData.syn_status == "Error" &&
                            retunDetailData.status == "Processing" && (
                              <>
                                {!disabled ? (
                                  <a
                                    className={
                                      classes.theAddCustomActionBtnFill
                                    }
                                    onClick={() => handleSubmitReport()}
                                  >
                                    <Paragraph margin="0 0 0 .4rem">
                                      Confirm Issue/Return
                                    </Paragraph>
                                  </a>
                                ) : (
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      width: "100px",
                                      height: "35px",
                                    }}
                                  >
                                    <Loader
                                      type="snipper-default"
                                      bgColor={"#878787"}
                                      size={30}
                                    />
                                  </div>
                                )}
                              </>
                            )}
                        </div>
                        <br />
                        <br />
                      </div>
                    </React.Fragment>
                  )}
                </Section>
              }
            />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
